import { useTranslation } from 'react-i18next';

import { createModal, ModalSize } from '@/components/common/Modal/ModalBuilder';
import useLoggedInUserData from '@/hooks/useUserData/useLoggedInUserData';
import NewRequestForm from '@/pages/NewRequest/components/NewRequestForm';

import { useNewRequestModalLogic } from './useNewRequestModalLogic';

interface NewRequestModalProps {
    userId: string;
    userFullName: string;
    userEmail: string;
    startDate: Date;
    endDate: Date;
    onClose: () => void;
    onSuccess: () => void;
}

const NewRequestModal = ({
    userId,
    userFullName,
    userEmail,
    startDate,
    endDate,
    onClose,
    onSuccess,
}: NewRequestModalProps) => {
    const { t } = useTranslation();
    const { isLead } = useLoggedInUserData();

    const {
        newRequestFormik,
        limitsUsage,
        requestSummary,
        isLimitExceeded,
        isLoadingSummary,
        isSubmitting,
        isCreatedSuccess,
        onReset,
        reloadDataOnReset,
    } = useNewRequestModalLogic({
        userId,
        userFullName,
        userEmail,
        startDate,
        endDate,
        onSuccess,
    });

    return createModal()
        .withTitle(t('newApplication_navigationBar_new_title'))
        .withSize(ModalSize.WIDE)
        .withContent(
            <NewRequestForm
                formik={newRequestFormik}
                limitsUsage={limitsUsage}
                requestSummary={requestSummary}
                isLimitExceeded={isLimitExceeded}
                isLoadingSummary={isLoadingSummary}
                isSubmitting={isSubmitting}
                isCreatedSuccess={isCreatedSuccess}
                reloadDataOnReset={reloadDataOnReset}
                isLead={!!isLead}
                showButtons={true}
                isScheduleView
                onReset={onReset}
                onCancel={onClose}
            />
        )
        .withOnClose(onClose)
        .build();
};

export default NewRequestModal;
